import React, { useEffect, useState } from 'react';
import UserAPI from './UserAPI';
import InfoAPI from './InfoAPI';
import { formatTitleToDB, formatTitleToDisplay } from '../utils/Functions';
import { refreshTime } from '../utils/DisplaySettings';
import { Container, Row, Col, Button, Table } from 'react-bootstrap';
import { secondaryColor } from '../utils/DisplaySettings';

const Leaderboard = () => {
    const [leaderBoard, setLeaderBoard] = useState([]);
    
  const [lastSongName, setLastSongName] = useState(null);
  const [lastArtist, setLastArtist] = useState(null);

    const loadLeaderBoard = async () => {
        const idToken = localStorage.getItem('idToken');
        const payloadBase64 = idToken.split('.')[1];
        const decodedPayload = JSON.parse(atob(payloadBase64.replace(/-/g, '+').replace(/_/g, '/')));
        const session_name = decodedPayload['cognito:username'];
        const requestBody = JSON.stringify({
            'request_type': 'info',
            'session_name': session_name,
            'info_type': 'leaderboard'
        });
        const jsonData = await InfoAPI(requestBody);
        if (jsonData) {
            const result = JSON.parse(jsonData.body);
            const newLeaderBoard = result.map(element => ({
                user: element[0],
                points: element[1],
                request: element[2] && element[3] 
                    ? formatTitleToDisplay(element[3]) + ' by ' + formatTitleToDisplay(element[2])
                    : ''
            }));
            setLeaderBoard(newLeaderBoard);
        }
    };

    useEffect(() => {
        console.log('Setting up leaderboard interval');
        let mounted = true;
        let intervalId = null;

        const loadData = async () => {
            if (mounted) {
                await loadLeaderBoard();
                await getSongPlayed();
            }
        };

        // Initial load
        loadData();

        // Set up interval
        intervalId = setInterval(() => {
            loadData();
        }, refreshTime);

        // Cleanup function
        return () => {
            console.log('Cleaning up leaderboard interval');
            mounted = false;
            if (intervalId) {
                clearInterval(intervalId);
                console.log('Interval cleared');
            }
        };
    }, []); // Empty dependency array since we don't need any dependencies

    const resetLeaderBoard = async () => {
        console.log('Resetting leaderboard');
        const requestBody = JSON.stringify({
            'request_type': 'user',
            'idToken': localStorage.getItem('idToken'),
            'user_request_type': 'event',
            'event_type': 'startLeaderBoard'
        });
        await UserAPI(requestBody);
        await loadLeaderBoard();
    };

    const getSongPlayed = async () => {
        const requestBody = JSON.stringify({
        'request_type': 'info',
          'session_name': JSON.parse(atob(localStorage.getItem('idToken').split('.')[1].replace(/-/g, '+').replace(/_/g, '/')))['cognito:username'],
          'info_type': 'songplayed'
        });
        const jsonData = await InfoAPI(requestBody);
        const result = JSON.parse(jsonData.body);
        
        var song= result.song_name;
        var artist= result.artist_name;
        if (song && artist) {
          song= formatTitleToDisplay(song);
          artist=formatTitleToDisplay(artist);
          setLastSongName(song);
          setLastArtist(artist);
        }
      };

    const songGrant = async (index) => {
        console.log('Granting song to user:', leaderBoard[index].user);
        const requestBody = JSON.stringify({
            'request_type': 'user',
            'idToken': localStorage.getItem('idToken'),
            'user_request_type': 'event',
            'event_type': 'takesongrequest',
            'user_name': leaderBoard[index].user
        });
        await UserAPI(requestBody);
        await loadLeaderBoard();
    };

    return (
        <Container fluid className="p-2">
            {lastSongName !== null && (
                <Row className="mb-2">
                    <Col>
                        <p className="text-white mb-0 small">
                            Playing: {lastSongName} by {lastArtist}
                        </p>
                    </Col>
                </Row>
            )}

            <Row className="mb-2">
                <Col className="text-center">
                    <Button 
                        variant="outline-light"
                        onClick={resetLeaderBoard}
                        size="sm"
                    >
                        Reset leader board
                    </Button>
                </Col>
            </Row>

            <Row>
                <Col>
                    <div className="table-responsive">
                        <Table variant="dark" hover size="sm" className="small">
                            <thead>
                                <tr>
                                    <th style={{ width: '25%', whiteSpace: 'nowrap' }}>Viewer</th>
                                    <th style={{ width: '25%', whiteSpace: 'nowrap' }}>Points</th>
                                    <th style={{ width: '25%' }}>Request</th>
                                    <th style={{ width: '25%' }} className="text-end"></th>
                                </tr>
                            </thead>
                            <tbody>
                                {leaderBoard.length > 0 && 
                                    leaderBoard.map((user, index) => (
                                        <tr key={index}>
                                            <td className="text-truncate" style={{ maxWidth: '150px' }}>{user.user}</td>
                                            <td className="text-truncate">{user.points}</td>
                                            <td className="text-truncate" style={{ maxWidth: '200px' }}>{user.request}</td>
                                            <td className="text-end">
                                                <Button 
                                                    variant="outline-light"
                                                    size="sm"
                                                    className="py-0 px-2"
                                                    onClick={() => songGrant(index)}
                                                >
                                                    Grant
                                                </Button>
                                            </td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </Table>
                    </div>
                </Col>
            </Row>
        </Container>
    );
};

export default Leaderboard;
